const Youtube = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M17.812 5.01663H6.145C3.855 5.01663 2 6.85163 2 9.11563V14.8836C2 17.1476 3.856 18.9836 6.145 18.9836H17.812C20.102 18.9836 21.957 17.1476 21.957 14.8836V9.11563C21.957 6.85163 20.101 5.01562 17.812 5.01562V5.01663ZM15.009 12.2796L9.552 14.8546C9.51872 14.8707 9.48192 14.878 9.44503 14.876C9.40815 14.874 9.37237 14.8626 9.34103 14.8431C9.3097 14.8235 9.28382 14.7964 9.2658 14.7641C9.24779 14.7318 9.23822 14.6956 9.238 14.6586V9.34963C9.23867 9.3125 9.24872 9.27614 9.26722 9.24395C9.28573 9.21176 9.31208 9.18477 9.34382 9.1655C9.37556 9.14624 9.41167 9.13532 9.44877 9.13377C9.48587 9.13221 9.52276 9.14008 9.556 9.15663L15.014 11.8916C15.0504 11.9098 15.0809 11.9378 15.102 11.9725C15.1232 12.0071 15.1341 12.0471 15.1336 12.0877C15.1331 12.1283 15.1211 12.168 15.0991 12.2021C15.077 12.2362 15.0458 12.2634 15.009 12.2806V12.2796Z"
      fill="currentColor"
    />
  </svg>
);

export default Youtube;
